import React from 'react';
import PropTypes from 'prop-types';
import autobind from "autobind-decorator";
import { connect } from 'react-redux';

import { PureComponent } from 'core/components';
import { Icon } from 'core/components/Framework7';
import { addToCart, deleteItem, changeCountItem } from 'content/pages/Cart/Module';
import { CartItem } from 'content/components';

import classes from './styles.module.css';

class CartProduct extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {}
  }

  renderCartItems() {
    const { items } = this.props
    // console.log('items:', items)

    if (!items || items.length === 0) return this.empty()

    return items.map(item => {
      return this.renderCartItem(item)
    })
  }

  empty() {
    return (
      <div className={classes.empty}>
        <Icon icon="mdi-basket" />
        <div>سبد خرید شما خالی است</div>
      </div>
    )
  }

  renderCartItem(item) {
    const { readOnly } = this.props;
    // console.log('cart item:', item)

    if (item.deletedAt) {
      return
    }

    return <CartItem key={item.id} item={item} readOnly={readOnly} />
  }

  render() {
    const { items } = this.props
    // console.log('items:', items)

    return (
      <div
        style={{ height: !items || items.length === 0 ? '100%' : 'auto' }}
        className={classes.cartItems}
      >
        {this.renderCartItems()}
      </div>
    )
  }
}

CartProduct.propTypes = {
  items: PropTypes.array,
}

export default connect(
  state => ({
  }),
  {
    addToCart,
    deleteItem,
    changeCountItem
  }
)(autobind(CartProduct));
